import { SEASON_ENUM } from "../enums/season";
import logo from '../assets/logo.svg'
import logoNewYear from '../assets/logoNewYear.svg'
import logoMarch from '../assets/logoMarch.svg'
import logoHalloween from '../assets/logoHalloween.svg'

export const getSeason = () =>{
    const today = new Date();
    const currentMonth = today.getMonth() + 1;
    const currentDay = today.getDate();
    if((currentMonth === 12 && currentDay >= 1) || (currentMonth === 1 && currentDay <= 14)){
        return SEASON_ENUM.NEWYEAR;
    }
    if(currentMonth === 3 && currentDay >= 8 && currentDay <= 31){
        return SEASON_ENUM.MARCH
    }
    if((currentMonth === 10 && currentDay >= 17) || (currentMonth === 11 && currentDay <= 2)){
        return SEASON_ENUM.HALLOWEEN
    }
    return ''
}

export const getSeasonLogo = () =>{
    const isNewYear = getSeason() === SEASON_ENUM.NEWYEAR;
    const isMarch = getSeason() === SEASON_ENUM.MARCH;
    const isHalloween = getSeason() === SEASON_ENUM.HALLOWEEN;
    if(isNewYear) return logoNewYear
    if(isMarch) return logoMarch
    if(isHalloween) return logoHalloween
    return logo
}